import { createFileRoute } from '@tanstack/react-router'

import { ExclusionsConfigurationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/exclusions-configuration-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/exclusions/configuration')({
  component: () => (
    <PermissionChecker requiredPermissions={['exclusionActivation.read']}>
      <ExclusionsConfigurationPage />
    </PermissionChecker>
  ),
})
